export default __webpack_public_path__ + "static/media/SoftwareEng.b867d7a5.jpg";